import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

export function useEmployeesNotInPayrollData(payrollId: number) {
    const { data: employees, isPending: isLoadingEmployees } = useQuery({
        queryKey: ['employees-not-in-payroll', payrollId],
        queryFn: async () => {
            const { data } = await axios.get(
                route('v2.salary.payrolls.employees.not-in-payroll', { payroll: payrollId }),
            );
            return data;
        },
        placeholderData: [],
    });

    return {
        employees,
        isLoadingEmployees,
    };
}
